"use client";

// 서브필터 '초기화' — 페이지 이동 없이 사이드바 폼의 보이는 입력(지역·지원대상·접수상태·주관기관·키워드)만
//   빈 값으로 되돌린다. hidden(q·domain·cat2 등 맥락)과 상단 검색창은 건드리지 않음. 적용은 '검색' 클릭.
export function ResetSubFilters({
  formId,
  style,
  children,
}: {
  formId: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}) {
  function reset() {
    const form = document.getElementById(formId) as HTMLFormElement | null;
    if (!form) return;
    form.querySelectorAll<HTMLInputElement | HTMLSelectElement>("input, select").forEach((el) => {
      if (el instanceof HTMLInputElement && el.type === "hidden") return; // 맥락(hidden) 보존
      el.value = "";
    });
  }
  return (
    <button type="button" onClick={reset} style={{ appearance: "none", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", padding: 0, ...style }}>
      {children}
    </button>
  );
}
